import { UI, VStack } from '@genial/components';
import React from 'react';

export const SubscriptionHistoryEmptyList: React.FC = () => {
  return (
    <VStack py="stack.huge">
      <UI.ErrorBoundary
        errorIconOrIllustration="NotEmptyIllustration"
        errorTitle="Nenhum item encontrado."
        errorMessage="Não existe nenhum item nesta seção."
      />
    </VStack>
  );
};
